// extracted by mini-css-extract-plugin
export default {"modal-btns-container":"SoldModal_modal-btns-container__fgMfw","cancel-btn":"SoldModal_cancel-btn__+VEle","sold-modal":"SoldModal_sold-modal__cIV2t"};